import script from "./ProviderCatalogCardSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProviderCatalogCardSkeleton.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__